module.exports = __webpack_public_path__ + "static/media/bootstrap.7b4c3807.png";